module.exports = __webpack_public_path__ + "static/media/NotFoundNew.e03d40a7.png";